'use client';

import { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import ReactSelect from 'react-select';
import { CustomOption } from './custom-components/custom-option';
import { CustomMenu } from './custom-components/custom-menu';
import { CustomDropdownIndicator } from './custom-components/custom-dropdown-indicator';
import { CustomClearIndicator } from './custom-components/custom-clear-indicator';
import { createSelectStyles } from './select-styles';

import type { TOption, TSelect } from './types';

export const Select: FC<TSelect> = ({
  options,
  label,
  required,
  id,
  value,
  onChange,
  placeholder = 'Wybierz...',
  blacked = false,
  className,
  menuPlacement = 'bottom',
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className={twMerge('flex flex-col text-foreground gap-1.5', className)}>
      <label
        htmlFor={id}
        className={twMerge('tracking-wider font-semibold text-sm pl-1', blacked && 'text-background')}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {label}
        {required && <span className="ml-0.5 text-red-600">*</span>}
      </label>
      <ReactSelect
        styles={createSelectStyles({ blacked, isHovered })}
        components={{
          Option: CustomOption,
          Menu: CustomMenu,
          DropdownIndicator: CustomDropdownIndicator,
          ClearIndicator: CustomClearIndicator,
        }}
        options={options}
        name={id}
        inputId={id}
        instanceId={id}
        aria-label={label}
        onChange={(option: unknown) => onChange?.((option as TOption | null) ?? null)}
        value={value ?? null}
        placeholder={placeholder}
        menuPlacement={menuPlacement}
        openMenuOnFocus
        isClearable
      />
    </div>
  );
};
